import React from 'react'

export interface User {
  last_name: string
  first_name: string
  middle_name: string
  party_number: string
  region: string
  ro_id: number
  mo_id: number
  po_id: number
  ro_name: string
  mo_name: string
  po_name: string
}

export interface UserContextProps {
  currentUser: User | null
  setCurrentUser: React.Dispatch<React.SetStateAction<User | null>>
}

export const UserContext = React.createContext<UserContextProps | undefined>(undefined)
